export default object => {
    //tab booleans
    let generalItems = false;
    let questionsItems = false;
    let ratingsItems = false;

    // trimming variables
    let description;
    let objective;
    let concerns;
    let aadeliverable;
    let keyParticipants;
    let problems;
    let comments;
    let targetMarketComments;
    let comingOfAgeComments;
    let influentialComments;
    let communityRelationsComments;
    let leadGenerationComments;
    console.log('tab validation triggered');
    // General trimming
    if (typeof object.description === 'string') {
        description = object.description.trim();
    } else {
        description = object.description;
    }
    if (typeof object.objective === 'string') {
        objective = object.objective.trim();
    } else {
        objective = object.objective;
    }
    if (typeof object.concerns === 'string') {
        concerns = object.concerns.trim();
    } else {
        concerns = object.concerns;
    }
    if (typeof object.aadeliverable === 'string') {
        aadeliverable = object.aadeliverable.trim();
    } else {
        aadeliverable = object.aadeliverable;
    }

    // Questions trimming
    if (typeof object.keyParticipants === 'string') {
        keyParticipants = object.keyParticipants.trim();
    } else {
        keyParticipants = object.keyParticipants;
    }
    if (typeof object.problems === 'string') {
        problems = object.problems.trim();
    } else {
        problems = object.problems;
    }
    if (typeof object.comments === 'string') {
        comments = object.comments.trim();
    } else {
        comments = object.comments;
    }
    // Ratings trimming
    if (typeof object.targetMarketComments === 'string') {
        targetMarketComments = object.targetMarketComments.trim();
    } else {
        targetMarketComments = object.targetMarketComments;
    }
    if (typeof object.comingOfAgeComments === 'string') {
        comingOfAgeComments = object.comingOfAgeComments.trim();
    } else {
        comingOfAgeComments = object.comingOfAgeComments;
    }
    if (typeof object.influentialComments === 'string') {
        influentialComments = object.influentialComments.trim();
    } else {
        influentialComments = object.influentialComments;
    }
    if (typeof object.communityRelationsComments === 'string') {
        communityRelationsComments = object.communityRelationsComments.trim();
    } else {
        communityRelationsComments = object.communityRelationsComments;
    }
    if (typeof object.leadGenerationComments === 'string') {
        leadGenerationComments = object.leadGenerationComments.trim();
    } else {
        leadGenerationComments = object.leadGenerationComments;
    }
    // General tab
    if (
        description !== '' &&
        objective !== '' &&
        concerns !== '' &&
        ((typeof object.attendance === 'number' ||
            typeof object.attendance === 'string') &&
            object.attendance !== '') &&
        ((typeof object.engagements === 'number' ||
            typeof object.engagements === 'string') &&
            object.engagements !== '') &&
        ((typeof object.mediaPosts === 'number' ||
            typeof object.mediaPosts === 'string') &&
            object.mediaPosts !== '') &&
        ((typeof object.mediaImpressions === 'number' ||
            typeof object.mediaImpressions === 'string') &&
            object.mediaImpressions !== '') &&
        ((typeof object.socialMediaPosts === 'number' ||
            typeof object.socialMediaPosts === 'string') &&
            object.socialMediaPosts !== '') &&
        ((typeof object.socialMediaImpressions === 'number' ||
            typeof object.socialMediaImpressions === 'string') &&
            object.socialMediaImpressions !== '') &&
        ((typeof object.influencerContacts === 'number' ||
            typeof object.influencerContacts === 'string') &&
            object.influencerContacts !== '') &&
        ((typeof object.followUps === 'number' ||
            typeof object.followUps === 'string') &&
            object.followUps !== '') &&
        ((typeof object.interaction === 'number' ||
            typeof object.interaction === 'string') &&
            object.interaction !== '') &&
        ((typeof object.influencerInteraction === 'number' ||
            typeof object.influencerInteraction === 'string') &&
            object.influencerInteraction !== '') &&
        aadeliverable !== ''
    ) {
        if (object.aaawareness !== true && object.aabehavior !== true) {
            generalItems = false;
        } else {
            generalItems = true;
        }
    }

    // Questions tab
    if (
        object.attended &&
        object.electricity &&
        object.accommodating &&
        (object.aaRecommend || object.recommend) &&
        object.emvAttend &&
        object.attendance &&
        keyParticipants &&
        problems &&
        comments
    ) {
        if (
            object.attended !== '' &&
            object.attended !== 'null' &&
            object.attended !== null &&
            (object.electricity !== '' &&
                object.electricity !== 'null' &&
                object.electricity !== null) &&
            (object.accommodating !== '' &&
                object.accommodating !== 'null' &&
                object.accommodating !== null) &&
            (object.aaRecommend !== '' &&
                object.aaRecommend !== 'null' &&
                object.aaRecommend !== null) &&
            (object.emvAttend !== '' &&
                object.emvAttend !== 'null' &&
                object.emvAttend !== null) &&
            ((typeof object.marinesAttendance === 'number' ||
                typeof object.marinesAttendance === 'string') &&
                object.marinesAttendance !== '') &&
            keyParticipants !== '' &&
            problems !== '' &&
            comments !== ''
        ) {
            questionsItems = true;
        }
    }

    // Ratings tab
    if (
        object.targetMarketRating &&
        targetMarketComments !== '' &&
        object.comingOfAgeRating &&
        comingOfAgeComments !== '' &&
        object.influentialRating &&
        influentialComments !== '' &&
        object.communityRelationsRating &&
        communityRelationsComments !== '' &&
        object.leadGenerationRating &&
        leadGenerationComments !== '' &&
        ((typeof object.estimatedTargetAttendance === 'number' ||
            typeof object.estimatedTargetAttendance === 'string') &&
            object.estimatedTargetAttendance !== '')
    ) {
        ratingsItems = true;
    }

    const errors = [];
    if (!generalItems) {
        errors.push('Please complete all items in the General tab.');
    }
    if (!questionsItems) {
        errors.push('Please complete all items in the Questions tab.');
    }
    if (!ratingsItems) {
        errors.push('Please complete all items in the Ratings tab.');
    }

    let errString = null;
    if (errors.length > 0) {
        errString = errors.join('\n');
    }

    return errString;
};



// WEBPACK FOOTER //
// ./src/helpers/afterActionValidation.js